@if (user) {
  <button
    class="h-10! w-10! p-0! flex! align-center justify-center rounded-full bg-[var(--mat-sys-surface-container-high)] text-[var(--mat-sys-on-surface-variant)] hover:bg-[var(--mat-sys-surface-container-high-hover)] focus:bg-[var(--mat-sys-surface-container-high-focus)] active:bg-[var(--mat-sys-surface-container-high-pressed)]"
    mat-icon-button
    [matMenuTriggerFor]="profileMenu"
    matTooltip="Profile"
    aria-label="Open profile menu"
  >
    @if (profilePhotoUrl()) {
      <img
        class="h-10! w-10! shrink-0 rounded-full object-cover"
        [src]="profilePhotoUrl()"
        [alt]="user.first_name + ' ' + user.last_name"
        (error)="handleProfilePhotoError()"
      />
    } @else {
      <span class="flex h-10! w-10! items-center justify-center rounded-full bg-[var(--mat-sys-on-primary)] text-sm font-medium text-[var(--mat-sys-primary)]">
        {{ getProfileInitials() }}
      </span>
    }
  </button>

  <mat-menu #profileMenu="matMenu" xPosition="before" class="mt-[15px]">
    <button
      class="profile-summary h-auto! cursor-default! px-0!"
      mat-menu-item
      disableRipple
      (click)="$event.stopPropagation()"
    >
      <span
        class="flex w-full items-center gap-2 rounded-lg bg-[var(--mat-sys-surface-container-high)] p-4"
      >
        @if (profilePhotoUrl()) {
          <img
            class="h-14! w-14! shrink-0 rounded-full object-cover"
            [src]="profilePhotoUrl()"
            [alt]="user.first_name + ' ' + user.last_name"
            (error)="handleProfilePhotoError()"
          />
        } @else {
          <span class="flex h-14! w-14! items-center justify-center rounded-full bg-[var(--mat-sys-on-primary)] text-2xl font-medium text-[var(--mat-sys-primary)]">
        {{ getProfileInitials() }}
      </span>
        }
        <span class="min-w-0 flex-1">
          <span class="title-medium mb-1! block whitespace-normal break-normal">
            {{ user.first_name }} {{ user.last_name }}
          </span>
          <span
            class="body-medium mb-0! block whitespace-normal text-[var(--mat-sys-on-surface-variant)]"
          >
            {{ user.email }}
          </span>
        </span>
      </span>
    </button>

    <mat-divider></mat-divider>

    @if (visibleUserScopes().length > 0) {
      <!-- <mat-divider></mat-divider> -->

      <button class="user-view-trigger" mat-menu-item [matMenuTriggerFor]="userViewMenu">
        <span class="flex w-full items-center justify-between gap-6">
          <span>User view</span>
          <span class="body-small text-[var(--mat-sys-on-surface-variant)]">
            {{ selectedUserScopeLabel() }}
          </span>
        </span>
      </button>
    }

    <!-- <mat-divider></mat-divider> -->

    <button mat-menu-item (click)="handleSignOut()" [disabled]="isSigningOut">
      <mat-icon>logout</mat-icon>
      <span>{{ isSigningOut ? 'Signing out…' : 'Sign Out' }}</span>
    </button>
  </mat-menu>

  <mat-menu #userViewMenu="matMenu">
    @for (option of visibleUserScopes(); track option.value) {
      <button mat-menu-item (click)="userScope.setScope(option.value)">
        <mat-icon [class.invisible]="userScope.selectedScope() !== option.value">check</mat-icon>
        <span>{{ option.label }}</span>
      </button>
    }
  </mat-menu>
}
